import { TAGS, api } from "@/store/api.ts"
import { IPaginationRes } from "@/types"
import { IStoreAnyItem, IStoreDto, IStoreItem, STORE_ITEM_TYPES } from "."

const basePath = "/store"

export const storeApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.STORE]
})

export const storeEndpoints = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    getStore: builder.query<IPaginationRes<IStoreAnyItem>, IStoreDto>({
      query: (data) => ({
        url: `${basePath}`,
        method: "GET",
        params: data
      }),
      providesTags: (_, __, { type }) => {
        if (!type) return [{ type: TAGS.STORE, id: `STORE` }]
        return [
          { type: TAGS.STORE, id: `STORE` },
          { type: TAGS.STORE, id: `STORE:${type}` }
        ]
      }
    })
  })
})

type QueryResult<T> = Omit<
  ReturnType<typeof storeEndpoints.useGetStoreQuery>,
  "data" | "currentData"
> & {
  data: IPaginationRes<T> | undefined
  currentData: IPaginationRes<T> | undefined
}

export function useGetStoreQuery<T extends STORE_ITEM_TYPES>(
  arg: IStoreDto & { type: T },
  options?: Parameters<typeof storeEndpoints.useGetStoreQuery>[1]
): QueryResult<IStoreItem<T>>

export function useGetStoreQuery(
  arg: IStoreDto,
  options?: Parameters<typeof storeEndpoints.useGetStoreQuery>[1]
): QueryResult<IStoreAnyItem>

export function useGetStoreQuery(
  arg: IStoreDto,
  options?: Parameters<typeof storeEndpoints.useGetStoreQuery>[1]
) {
  return storeEndpoints.useGetStoreQuery(
    arg,
    options
  ) as unknown as QueryResult<IStoreAnyItem>
}
